export { default } from '../../event/[id]';
